module.exports = __webpack_public_path__ + "img/accurate-people-lookup.svg";